import React, { useEffect, useState } from 'react';
import { Html5Qrcode, Html5QrcodeScanner } from 'html5-qrcode';
import { useNavigate } from 'react-router-dom';

const EventFlowScanQR = ({ onScanSuccess }) => {
  const navigate = useNavigate();
  const [qrCodeData, setQrCodeData] = useState(null);
  const [error, setError] = useState(null);
  const [isCameraActive, setIsCameraActive] = useState(true); 
  const [scannedData, setScannedData] = useState('');

  useEffect(() => {
    if (isCameraActive) {
      const scanner = new Html5QrcodeScanner(
        "qr-reader", 
        { fps: 10, qrbox: { width: 250, height: 250 } }
      );

      // Function to choose the rear camera by default
    const videoConstraints = {
      facingMode: { exact: "environment" }, 
    };


      scanner.render(
        (decodedText) => {
          setQrCodeData(decodedText);
          setScannedData(decodedText); 
          onScanSuccess(decodedText);
          setError(null); // Clear any previous errors
        },
        (error) => {
          setError(`Camera Scan Error: ${error}`);
          console.error("Scan error:", error);
        }
      );

      return () => {
        scanner.clear(); 
      };
    }
  }, [isCameraActive, onScanSuccess]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const html5QrCode = new Html5Qrcode("qr-reader-file");
      html5QrCode.scanFile(file, true)
        .then((decodedText) => {
          // console.log("decodedText: ",decodedText);
          setQrCodeData(decodedText);
          setScannedData(decodedText);
          onScanSuccess(decodedText);
          setError(null); 
        })
        .catch((err) => {
          setError(`File Scan Error: ${err}`);
          setQrCodeData(null); 
        });
    }
  };

  const handleClose = () => {
    navigate(-1); 
  };

  return (
    <div className='min-h-[250h] flex justify-center items-center bg-teal-800'>
      <div className='flex flex-col justify-center items-center bg-white p-4 rounded-lg shadow-lg'>
        <h2 className="mb-4 text-2xl font-semibold text-blue-600">Think5Whys Scan QR Code</h2>
        
        {/* Toggle between Camera and File input */}
        {/* <div className="flex space-x-4 mb-4">
          <button
            className={`py-2 px-4 rounded-full ${isCameraActive ? 'bg-blue-500 text-white' : 'bg-gray-300 text-black'}`}
            onClick={() => setIsCameraActive(true)}
          >
            Use Camera
          </button>
          <button
            className={`py-2 px-4 rounded-full ${!isCameraActive ? 'bg-blue-500 text-white' : 'bg-gray-300 text-black'}`}
            onClick={() => setIsCameraActive(false)}
          >
            Upload Image
          </button>
        </div> */}

        {/* Camera QR Scanner */}
        {isCameraActive && (
          <div>
            <div id="qr-reader" style={{ width: '100%' }} />
            {scannedData && <p className="mt-4 text-center text-green-600">Scanned Data: {scannedData}</p>}
          </div>
        )}

        {/* File Input QR Scanner */}
        {!isCameraActive && (
          <div>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="mb-4"
            />
            <div id="qr-reader-file" style={{ display: 'none' }} />
          </div>
        )}

        {/* Display QR Code Data */}
        {/* {qrCodeData && (
          <div className="mt-4 p-4 bg-green-100 text-green-800 rounded-lg">
            <p>QR Code Data: {qrCodeData}</p>
          </div>
        )} */}

        {/* Display Error Message */}
        {error && (
          <div className="mt-4 p-4 bg-red-100 text-red-800 rounded-lg">
            <p>{error}</p>
          </div>
        )}

        <button
          className="mt-4 w-20 bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded-full transition duration-300"
          onClick={handleClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default EventFlowScanQR;
